// extracted by mini-css-extract-plugin
export default {"container":"bed-view-multi-alloc_container__MJcpv"};